export default __webpack_public_path__ + "ed1fa4703bd3737ec031e5b3cf36872d.svg";